import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onDidYouReceiveScholarshipChange, onIsPhdToggleChange, populateEndYearOnStartYearChange } from './PGHigherStudiesActions';
import PGHigherStudiesLayout from './PGHigherStudiesLayout';
import { getDomainValueForCode } from '../../../../library/Core/SmartFunctions';
import OutcomeInformationLayout from '../OutcomeInformationLayout';

const PgHigherStudies = (props: any) => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');
    const location = useLocation();
    const outcomeMatch = location.pathname.includes('outcome')
    console.log("outcomeMatch",outcomeMatch)

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            startYear: populateEndYearOnStartYearChange,
            isPhd: onIsPhdToggleChange,
            didYouReceiveScholarship: onDidYouReceiveScholarshipChange,
            REDIRECT: setRedirectUrl
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    let message = `Since you mentioned you are currently Pursuing Higher Studies, please provide the details.`
    let outcomeStudiesStatus = ['JOINED_DOCTORAL','HIGHER_STUDIES','JOINED_PG','WENT_FOR_HIGHER_STUDIES']
    if(outcomeStudiesStatus.includes(state?.data?.selectedInstitute?.postProgramCompletionStatusCode)){
        let program_name = getDomainValueForCode(state?.data?.selectedInstitute?.programId,'ALL_PROGRAM_CODE',state)
        // message = `After Completing ${program_name} from ${institute_name}, you mentioned that you went for higher studies. Please provide the details of the institute and course you joined after your program completion at ${institute_name}`
        message =`Since you mentioned you are currently Pursuing Higher Studies, please provide the details.`
    }
    else 
    if(state?.data?.profile?.presentEducationStatusCode == "PURSUING_STUDIES"){
        let program_level = state?.data?.profile?.pursuingEducationLevelCode
        message = `Since you mentioned you are currently Pursuing Higher Studies, please provide the details.`
    }


   

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <PGHigherStudiesLayout> {!state.flags.isDataLoading && <PageBuilder data={message} />}</PGHigherStudiesLayout>
        </SmartContext.Provider>
    );
};

export default PgHigherStudies;
